module.exports = "/_next/static/images/solar-installations-2265035c0035c66af75bc5cc68b3e38c.webp";